import React from 'react';
import { MarkdownPreview } from './MarkdownPreview';

interface SymptomQaPreviewProps {
  label: string;
  content: string;
}

export const SymptomQaPreview: React.FC<SymptomQaPreviewProps> = ({ label, content }) => {
  return (
    <div>
      <div className="mb-1.5 text-xs font-medium text-slate-500">プレビュー</div>
      <div
        style={{
          backgroundColor: '#F2F2F7',
          borderRadius: '8px',
          padding: '12px',
        }}
      >
        <div
          style={{
            backgroundColor: '#f5f5f5',
            borderRadius: '8px',
            padding: '16px',
          }}
        >
          <div style={{ fontSize: '14px', color: '#333333' }}>
            <span style={{ fontWeight: 600 }}>{label}</span> <MarkdownPreview content={content} />
          </div>
        </div>
      </div>
    </div>
  );
};
